module.exports = __webpack_public_path__ + "img/warrany-activation.28af7a7c.png";